"use client";
import { cn } from '@/lib/utils';
import { Prisma } from '@prisma/client';
import { JSONContent } from '@tiptap/core';
import { generateHTML } from '@tiptap/html';
import { EditorContent, useEditor } from '@tiptap/react';
import React, { useEffect, useState } from 'react';
import { getDefaultExtensions } from './extensions';

/** component to render TipTap generated content */
function TipTapRenderer({ JSON, ...props }: React.HTMLAttributes<HTMLDivElement> & { JSON: JSONContent | Prisma.JsonValue }) {
    const [serverRender, setServerRender] = useState(true);
    useEffect(() => {
        setServerRender(false)
    }, [])

    const editor = useEditor({
        "content": JSON as JSONContent,
        extensions: getDefaultExtensions({ "isServer": false }),
        editable: false,
        immediatelyRender: false,
    }, [JSON]);

    if (serverRender)
        return <div { ...props } className={ cn("tiptap ProseMirror", props.className) }
            dangerouslySetInnerHTML={ { __html: generateHTML(JSON as JSONContent, getDefaultExtensions({ "isServer": serverRender })) } }
        />

    return <EditorContent editor={ editor } contentEditable="false" { ...props } />
}

export default TipTapRenderer